import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    addTestcasesToTestplanError,
    addTestcasesToTestplanRequest,
    addTestcasesToTestplanSuccess,
    addTestPlanError,
    addTestPlanRequest,
    addTestPlanSuccess,
    deleteTestcasesFromTestplanError,
    deleteTestcasesFromTestplanRequest,
    deleteTestcasesFromTestplanSuccess,
    deleteTestPlanError,
    deleteTestPlanRequest,
    deleteTestPlanSuccess,
    duplicateTestplanError,
    duplicateTestplanRequest,
    duplicateTestplanSuccess,
    editTestPlanError,
    editTestPlanRequest,
    editTestPlanSuccess,
    getTestCasesFilteredByTestPlanError,
    getTestCasesFilteredByTestPlanRequest,
    getTestCasesFilteredByTestPlanSuccess,
    getTestPlanByIdError,
    getTestPlanByIdRequest,
    getTestPlanByIdSuccess,
    getTestPlanForUpdateTestRunError,
    getTestPlanForUpdateTestRunRequst,
    getTestPlanForUpdateTestRunSuccess,
    getTestPlansError,
    getTestPlansRequest,
    getTestPlansSuccess,
    getTestplanTypeError,
    getTestplanTypeRequest,
    getTestplanTypeSuccess,
} from './index';
import {
    addTestcasesToTestplan,
    addTestPlan,
    deleteTestcasesFromTestplan,
    deleteTestPlan,
    editTestPlan,
    getTestPlanById,
    getTestPlans,
    getTestplanType,
} from '../api/testPlansApi';
import { getTestCases } from '@pages/testcases/api/testсasesApi';
import { selectTestCasesFilteredByTestPlan, selectTestCasesFilteredByTestPlanCount } from './selectors';

export function* getTestPlansSaga(action) {
    try {
        const response = yield call(getTestPlans, action.payload);
        yield put(getTestPlansSuccess(response));
    } catch (error) {
        yield put(getTestPlansError(error));
    }
}

export function* getTestPlanByIdSaga(params) {
    try {
        let response = yield call(getTestPlanById, params.payload);
        yield put(getTestPlanByIdSuccess(response));
    } catch (error) {
        yield put(getTestPlanByIdError(error));
    }
}

export function* addTestPlanSaga(params) {
    try {
        const response = yield call(addTestPlan, params.payload);
        yield put(addTestPlanSuccess(response));
    } catch (error) {
        yield put(addTestPlanError(error));
    }
}

export function* editTestPlanSaga(params) {
    const { id, ...requestParams } = params.payload;

    try {
        yield call(editTestPlan, id, requestParams);
        yield put(editTestPlanSuccess());
        yield put(getTestPlanByIdRequest(id));
    } catch (error) {
        yield put(editTestPlanError(error));
    }
}

export function* deleteTestPlanSaga(params) {
    const id = params.payload;

    try {
        yield call(deleteTestPlan, id);
        yield put(deleteTestPlanSuccess());
    } catch (error) {
        yield put(deleteTestPlanError(error));
    }
}

export function* duplicateTestplanSaga(action) {
    const testplanToDuplicateId = action.payload.id;
    const testCasesFilteredByTestPlan = yield select(selectTestCasesFilteredByTestPlan);
    const testPlanData = yield select((state) =>
        state.testPlans.testPlans.find((testPlan) => testPlan.pk === testplanToDuplicateId),
    );

    try {
        if (!testPlanData) {
            throw new Error('Something went wrong');
        }

        const { pk, createdAt, ...cleanedTestPlanData } = testPlanData;

        const response = yield call(addTestPlan, {
            ...cleanedTestPlanData,
            title: action.payload.name,
            testcases_ids: testCasesFilteredByTestPlan.map((item) => item.pk),
        });

        yield put(duplicateTestplanSuccess(response));
    } catch (error) {
        yield put(duplicateTestplanError(error));
    }
}

export function* getTestCasesFilteredByTestPlanSaga(params) {
    try {
        const response = yield call(getTestCases, params.payload);
        yield put(getTestCasesFilteredByTestPlanSuccess(response));
    } catch (error) {
        yield put(getTestCasesFilteredByTestPlanError(error));
    }
}

export function* getTestPlanForUpdateTestRunSaga(params) {
    try {
        let response = yield call(getTestPlanById, params.payload);
        yield put(getTestPlanForUpdateTestRunSuccess(response));
    } catch (error) {
        yield put(getTestPlanForUpdateTestRunError(error));
    }
}

export function* addTestcasesToTestplanSaga(params) {
    try {
        const response = yield call(addTestcasesToTestplan, params.payload);
        yield put(addTestcasesToTestplanSuccess(response));
    } catch (error) {
        yield put(addTestcasesToTestplanError(error));
    }
}

export function* deleteTestcasesFromTestplanSaga(params) {
    try {
        const { testplanId, testcase_ids } = params.payload;
        const totalCount = yield select(selectTestCasesFilteredByTestPlanCount);

        const response = yield call(deleteTestcasesFromTestplan, params.payload);
        yield put(deleteTestcasesFromTestplanSuccess(response));

        const remainingCount = totalCount - testcase_ids.length;
        if (remainingCount <= 0) {
            yield put(getTestPlanByIdRequest(testplanId));
        }
    } catch (error) {
        yield put(deleteTestcasesFromTestplanError(error));
    }
}

export function* getTestplanTypeSaga(params) {
    try {
        const response = yield call(getTestplanType, params.payload);
        yield put(getTestplanTypeSuccess(response.data));
    } catch (error) {
        yield put(getTestplanTypeError(error));
    }
}

export default function* testPlansSagaWatcher() {
    yield all([
        takeLatest(getTestPlansRequest, getTestPlansSaga),
        takeLatest(getTestPlanByIdRequest, getTestPlanByIdSaga),
        takeLatest(addTestPlanRequest, addTestPlanSaga),
        takeLatest(editTestPlanRequest, editTestPlanSaga),
        takeLatest(deleteTestPlanRequest, deleteTestPlanSaga),
        takeLatest(duplicateTestplanRequest, duplicateTestplanSaga),
        takeLatest(getTestCasesFilteredByTestPlanRequest, getTestCasesFilteredByTestPlanSaga),
        takeLatest(getTestPlanForUpdateTestRunRequst, getTestPlanForUpdateTestRunSaga),
        takeLatest(addTestcasesToTestplanRequest, addTestcasesToTestplanSaga),
        takeLatest(deleteTestcasesFromTestplanRequest, deleteTestcasesFromTestplanSaga),
        takeLatest(getTestplanTypeRequest, getTestplanTypeSaga),
    ]);
}
